<h2 i18n><span>S</span>obre mi</h2>
<div id="about_container" class="{{language}}">
    <p id="about_container_text_description" [innerHtml]="getSafeHtml()"></p><span class="blinking-cursor">|</span>
</div>
